import React, { useEffect, useState } from 'react';
import { Button, Tooltip, Typography } from '@mui/material';
import API from 'src/utils/api';
import RefreshButton from './RefreshButton';
import OutlinedText from './OutlinedText';
import { useInterval } from '../hooks/useInterval';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme => ({
  buttonWrapper: {
    display: 'flex',
    position: 'relative',
    width: 'fit-content'
  },
  button: {
    margin: 0
  },
  queueNumber: {
    fontWeight: 'bold',
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    pointerEvents: 'none'
  }
}));

export default function StatisticsButton({ id = 0, type = 0, fromDate = '1970-01-01', toDate = '1970-01-01'}) {
  const classes = useStyles();
  const [disabled, setDisabled] = useState(true);
  const [queueNumber, setQueueNumber] = useState(0);

  useEffect(() => {
    checkQueue();
  }, [id, type, fromDate, toDate]);

  useInterval(() => {
    checkQueue();
  }, 10000);

  const checkQueue = () => {
    if (!fromDate || !toDate)
      return;
    API.canReloadCache(id, type, fromDate, toDate).then(res => {
      const { canReload, queueNumber } = res;
      setDisabled(!canReload);
      setQueueNumber(queueNumber);
    });
  };

  const handleClick = async () => {
    setDisabled(true);
    await API.reloadCache(id, type, fromDate, toDate);
    checkQueue();
  };

  const text = <div>Tryck här för att ladda om cachetabeller för den här perioden</div>;
  const test = <div>En omladdning för den här perioden är redan köad<br />Könummer: {queueNumber}</div>;

  return (
    <Tooltip title={disabled ? test : text} style={{ whiteSpace: 'pre-line' }} placement='right'>
      <div className={classes.buttonWrapper}>
        <RefreshButton
          onClick={handleClick}
          updateRequired={!disabled}
          disabled={disabled}
          size={40}
          marginRight={0}
        />
        {/* <Typography color="textPrimary" className={classes.queueNumber}>{queueNumber}</Typography> */}
        {disabled && queueNumber > 0 && <OutlinedText text={queueNumber} className={classes.queueNumber} />}
      </div>
    </Tooltip>
  );

  return (
    <Button
      variant="contained"
      color="primary"
      disabled={disabled}
      onClick={handleClick}
    >
      Ladda om perioden
    </Button>
  );
}

/*StatisticsButton.defaultProps = {
  id: 0,
  type: 0,
  fromDate: '1970-01-01',
  toDate: '1970-01-01'
}*/